import React, { useState } from 'react'
import { Collapse, Divider, Icon, IconButton, List, ListItem, ListItemIcon, ListItemText, SwipeableDrawer } from '@mui/material'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { withStyles } from '@mui/styles'
import { style } from 'styles'

function CategoriesDrawer({ classes, onToggle, open }) {
	const navigate = useNavigate()
	const { categories } = useSelector(state => state.products)
	const [searchText, setSearchText] = useState('')

	const handleSearch = (e) => {
		e.preventDefault()
		navigate(`/shop/search?s=${searchText}`)
		onToggle(false)
	}

	const gotoOffers = () => {
		onToggle(false)
		navigate('/offers')
	}

	return (<SwipeableDrawer
		anchor="left"
		open={open}
		onClose={() => onToggle(false)}
		onOpen={() => onToggle(true)}
		classes={{ paper: classes.categoriesDrawer }}
	>
		<List component="nav" aria-label="main mailbox folders" className="categories">
			<div className="close">
				<IconButton aria-label="chiudi" component="span" onClick={() => { onToggle(false) }}>
					<Icon>cancel</Icon>
				</IconButton>
			</div>
			<form onSubmit={handleSearch}>
				<div className="search">
					<IconButton color="primary" aria-label="cerca" component="span" onClick={handleSearch} className="searchButton">
						<Icon>search</Icon>
					</IconButton>
					<input onChange={(e) => setSearchText(e.target.value)} value={searchText} name="searchText" />
				</div>
			</form>
			<Categories
				categories={categories}
				level={0}
				onToggle={onToggle}
			/>
			<ListItem button className="category" onClick={gotoOffers} style={{ paddingLeft: 10 }}>
				<ListItemIcon>
					<Icon>local_offer</Icon>
				</ListItemIcon>
				<ListItemText primary={'Offerte'} />
			</ListItem>
			<Divider />
		</List>
	</SwipeableDrawer>)
}

function Categories({ categories, level, onToggle }) {
	const navigate = useNavigate()
	const [openCategory, setOpenCategory] = useState(null)

	const categorySelect = (category) => {
		if (category.sub_categories.length > 0) {
			if (openCategory == category.category_id) {
				setOpenCategory(null)
			} else {
				setOpenCategory(category.category_id)
			}
		} else {
			navigate(`/shop/${category.ecom_url}`)
			onToggle(false)
		}
	}

	return (<React.Fragment>
		{categories.map((category, c) => (<React.Fragment key={c}>
			<ListItem button className="category" onClick={() => categorySelect(category) } style={{ paddingLeft: (level + 1) * 10 }}>
				{level == 0 && <ListItemIcon>
					<Icon>chevron_right</Icon>
				</ListItemIcon>}
				<ListItemText primary={category.name} />
				{category.sub_categories.length > 0 && <Icon>{openCategory == category.category_id ? 'expand_less' : 'expand_more'}</Icon>}
			</ListItem>
			<Divider />
			{category.sub_categories.length > 0 && <Collapse in={openCategory == category.category_id} timeout="auto" unmountOnExit>
				<List component="div" disablePadding>
					<Categories
						categories={category.sub_categories}
						level={level + 1}
						onToggle={onToggle}
					/>
				</List>
			</Collapse>}
		</React.Fragment>))}
	</React.Fragment>)
}

export default withStyles(style)(CategoriesDrawer)
